export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Für welche Klassenstufen ist Musik Startklar?',
    answer: 'Von Klasse 1 bis 9 — Grundschule und Sekundarstufe I.',
  },
  {
    question: 'Ist es für mein Bundesland geeignet?',
    answer:
      'Ja, das Material ist kompetenzorientiert und für alle Bundesländer geeignet.',
  },
  {
    question: 'Welches Format bekomme ich?',
    answer: 'Alle Hefte als PDF — zum Drucken oder für den Bildschirm.',
  },
  {
    question: 'Wie erhalte ich das Paket?',
    answer: 'Sofort nach dem Kauf als Download.',
  },
  {
    question: 'Kann ich es für eine ganze Klasse oder mehrere Kinder nutzen?',
    answer: 'Ja, du darfst es beliebig oft für deinen Unterricht ausdrucken.',
  },
  {
    question: 'Brauche ich Vorkenntnisse, um es einzusetzen?',
    answer: 'Nein, die Stunden sind auch fachfremd sofort einsetzbar.',
  },
  {
    question: 'Ist es einmalig zu bezahlen?',
    answer: 'Ja, du zahlst einmal 19 € und nutzt alles dauerhaft.',
  },
]
